import { Button, Col, Row, Space, Typography } from "antd";
import Container from "components/Common/Container";
import TImage from "components/Common/TImage";
import PublicFooter from "components/Layouts/Public/PublicFooter/PublicFooter";
import PublicLayout, {
  signupRedirect,
} from "components/Layouts/Public/PublicLayout";
import PublicNav from "components/Layouts/Public/PublicNav/PublicNav";
import AboutSEO from "components/PublicPages/About/AboutSEO";
import ContactUS from "components/PublicPages/Contact/ContactUs";
import Link from "next/link";
import ImgAboutJourney from "public/images/about/img-about-journey.svg";
import ImgAboutTeam from "public/images/about/img-at-bg.svg";
import Slide1 from "public/images/about/Slide1.jpg";
import Slide2 from "public/images/about/Slide2.jpg";
import Slide3 from "public/images/about/Slide3.jpg";
import Slide4 from "public/images/about/Slide4.jpg";
import Slide5 from "public/images/about/Slide5.jpg";
import Slide6 from "public/images/about/Slide6.jpg";
import Slide7 from "public/images/about/Slide7.jpg";
import Slide8 from "public/images/about/Slide8.jpg";
import { FiArrowRight } from "react-icons/fi";
import { EffectCards } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/scss";
import "swiper/scss/effect-cards";
import { Analytics } from "utils/Analytics/AnalyticsHelper";

const { Title, Text, Paragraph } = Typography;

const About: React.FC = () => {
  const TeamData = [
    {
      id: 1,
      name: "Dinesh",
      department: "Technology",
      img: "/images/about/Dinesh.png",
      username: "dinesh",
    },
    {
      id: 2,
      name: "Ankit",
      department: "Business",
      img: "/images/about/ankit.png",
      username: "ankit",
    },
    {
      id: 3,
      name: "Aditya",
      department: "Technology",
      img: "/images/about/aditya.png",
      username: "adityajoshi",
    },
    {
      id: 4,
      name: "Nimit",
      department: "Technology",
      img: "/images/about/nimit.png",
      username: "nimit",
    },
    {
      id: 5,
      name: "Nilesh",
      department: "Technology",
      img: "/images/about/Nilesh.png",
      username: "nilesh",
    },
    {
      id: 6,
      name: "Shagun",
      department: "Technology",
      img: "/images/about/shagun.png",
      username: "shagun",
    },
    {
      id: 7,
      name: "Akshay",
      department: "Data",
      img: "/images/about/akshay.png",
      username: "akshay",
    },
    {
      id: 8,
      name: "Yash",
      department: "Product",
      img: "/images/about/yash.png",
      username: "yash",
    },
    {
      id: 9,
      name: "Pawan",
      department: "Design",
      img: "/images/about/pawan.png",
      username: "pawanpreet",
    },
    {
      id: 10,
      name: "Shubham",
      department: "Strategy",
      img: "/images/about/shubham.png",
      username: "shubham",
    },
    {
      id: 11,
      name: "Hitesh",
      department: "QA",
      img: "/images/about/Hitesh.png",
      username: "hiteshvish123",
    },
    {
      id: 12,
      name: "Aman",
      department: "Business",
      img: "/images/about/aman.png",
      username: "aman_vijay",
    },
    {
      id: 13,
      name: "Abdullah",
      department: "Data",
      img: "/images/about/Abdullah.png",
      username: "abdullah",
    },
  ];

  return (
    <PublicLayout>
      <Container className="about" type="fluid">
        {/* SEO */}
        <AboutSEO />

        {/* Common Nav */}
        <PublicNav page="common" />

        {/* Main Hero Section */}
        <Container>
          <Row className="hero" align="middle" justify="center">
            <Col xs={{ span: 22, offset: 0 }} md={{ span: 14, offset: 0 }}>
              <Title level={1} className="title">
                Everyone has something to share and we want to enable just that
              </Title>
            </Col>
            <Col xs={{ span: 22, offset: 0 }} md={{ span: 10, offset: 0 }}>
              {/* Cards Effects */}
              <Paragraph className="about-swiper-wrapper">
                <Swiper
                  effect={"cards"}
                  grabCursor={true}
                  modules={[EffectCards]}
                  className="about-swiper"
                  loop
                >
                  <SwiperSlide>
                    <TImage
                      src={Slide1.src}
                      alt="Slide 1"
                      loading="lazy"
                      className="swiper-image"
                      width={340}
                      height={340}
                    />
                  </SwiperSlide>
                  <SwiperSlide>
                    <TImage
                      src={Slide2.src}
                      alt="Slide 2"
                      loading="lazy"
                      className="swiper-image"
                      width={340}
                      height={340}
                    />
                  </SwiperSlide>
                  <SwiperSlide>
                    <TImage
                      src={Slide3.src}
                      alt="Slide 3"
                      loading="lazy"
                      className="swiper-image"
                      width={340}
                      height={340}
                    />
                  </SwiperSlide>
                  <SwiperSlide>
                    <TImage
                      src={Slide4.src}
                      alt="Slide 4"
                      loading="lazy"
                      className="swiper-image"
                      width={340}
                      height={340}
                    />
                  </SwiperSlide>
                  <SwiperSlide>
                    <TImage
                      src={Slide5.src}
                      alt="Slide 5"
                      loading="lazy"
                      className="swiper-image"
                      width={340}
                      height={340}
                    />
                  </SwiperSlide>
                  <SwiperSlide>
                    <TImage
                      src={Slide6.src}
                      alt="Slide 6"
                      loading="lazy"
                      className="swiper-image"
                      width={340}
                      height={340}
                    />
                  </SwiperSlide>
                  <SwiperSlide>
                    <TImage
                      src={Slide7.src}
                      alt="Slide 7"
                      loading="lazy"
                      className="swiper-image"
                      width={340}
                      height={340}
                    />
                  </SwiperSlide>
                  <SwiperSlide>
                    <TImage
                      src={Slide8.src}
                      alt="Slide 8"
                      loading="lazy"
                      className="swiper-image"
                      width={340}
                      height={340}
                    />
                  </SwiperSlide>
                </Swiper>
              </Paragraph>
            </Col>
          </Row>
        </Container>

        {/* Founders Note */}
        <Container type="fluid" className="about-founders">
          <Paragraph className="founders-img-comment" />
          <Container>
            <Row justify="center">
              <Col xs={{ span: 22, offset: 0 }} md={{ span: 10, offset: 0 }}>
                <Title level={3} className="founders-title">
                  Open letter
                </Title>
                <TImage
                  src="/images/about/img-ankit.png"
                  alt="Ankit, Co-Founder"
                  className="founders-img"
                  width={370}
                  height={345}
                />
              </Col>
              <Col xs={{ span: 22, offset: 0 }} md={{ span: 14, offset: 0 }}>
                <Paragraph className="founders-text">
                  Out of the 80+ million creators in India, less than 0.5% earn
                  over Rs 15000 per month
                </Paragraph>

                <Paragraph className="founders-text">
                  Yup, while it&apos;s easier than ever to become a creator,
                  it&apos;s harder than ever to monetise it (thanks to the
                  insane competition) We think this needs to change.
                </Paragraph>

                <Paragraph className="founders-text">
                  That&apos;s why we are building Topmate - to empower creators,
                  experts and mentors like you to do what you love. Topmate
                  helps you leverage your personal brand to share your expertise
                  and monetise your time
                </Paragraph>

                <Paragraph className="ss-footer">
                  <TImage
                    src="/images/about/img-ankit.png"
                    alt="Ankit, Co-Founder"
                    className="founders-img"
                    width={370}
                    height={345}
                  />
                  <Paragraph className="ss-topmate-user">
                    <em>
                      <Text strong>Ankit Agarwal,</Text>{" "}
                      <Text>CEO & Founder of Topmate</Text>
                    </em>
                  </Paragraph>

                  <Link
                    href="/ankit"
                    target="_blank"
                    onClick={(): void =>
                      Analytics.track("book a call with founder")
                    }
                  >
                    <Button
                      className="ss-topmate-link"
                      type="text"
                      target="_blank"
                    >
                      <em>
                        <u>Book a demo ↗️</u>
                      </em>
                    </Button>
                  </Link>
                </Paragraph>
              </Col>
            </Row>
          </Container>
        </Container>

        {/* Team */}
        <Container type="fluid" className="about-team">
          <TImage
            src={ImgAboutTeam}
            className="at-bg-img"
            alt="Smiley bg"
            width={150}
            height={150}
          />
          <Container>
            <Row justify="center">
              <Col
                xs={{ span: 22, offset: 0 }}
                md={{ span: 4, offset: 0 }}
                flex={1}
              >
                <Paragraph className="at-title-wrapper">
                  <Title level={3} className="at-title">
                    The&nbsp;team
                  </Title>
                </Paragraph>
              </Col>
              <Col xs={{ span: 22, offset: 0 }} md={{ span: 18, offset: 2 }}>
                <Row gutter={{ xs: 16, sm: 16, md: 36, lg: 36 }}>
                  {TeamData?.map((team) => (
                    <Col
                      className="team-card"
                      xs={{ span: 12, offset: 0 }}
                      md={{ span: 6, offset: 0 }}
                      key={team?.id}
                    >
                      <Paragraph
                        className="at-card cursor-hover"
                        onClick={() => {
                          Analytics.track("expert_profile_clicked", {
                            screename: "About",
                            username: team?.username,
                          }),
                            window.open(`/${team?.username}`, "_blank");
                        }}
                      >
                        <TImage
                          src={team.img}
                          alt={team.name}
                          width={150}
                          height={150}
                          className="at-card-img"
                        />
                        <Paragraph className="at-card-name">
                          {team.name}
                        </Paragraph>
                        <Paragraph className="at-card-department">
                          {team.department}
                        </Paragraph>
                      </Paragraph>
                    </Col>
                  ))}
                </Row>
              </Col>
            </Row>
          </Container>
        </Container>

        {/* Journey */}
        <Container type="fluid" className="about-journey">
          <TImage
            src={ImgAboutJourney}
            className="aj-bg-img"
            alt="About Journey BG"
          />
          <Container>
            <Row justify="center">
              <Col xs={22} md={11} flex={1}>
                <Title level={3} className="aj-title">
                  On a journey where we all win together
                </Title>
                <Link
                  href={signupRedirect()}
                  onClick={(): void =>
                    Analytics.track("invite_clicked", {
                      Position: "Below Team",
                      Type: "About Page",
                    })
                  }
                >
                  <Button className="aj-cta">
                    <Text strong>Start today</Text>
                    <FiArrowRight size={24} />
                  </Button>
                </Link>
              </Col>
              <Col
                xs={{ span: 22, offset: 0 }}
                md={{ span: 10, offset: 3 }}
                flex={1}
              >
                <Paragraph className="aj-content">
                  We believe everyone has something to share. That&apos;s why
                  Topmate empowers you to be able to share your knowledge with
                  your followers - in the most authentic forms of human
                  connection. Our mission is to help you make a living doing
                  what you love
                  <Link
                    href={signupRedirect()}
                    onClick={(): void =>
                      Analytics.track("invite_clicked", {
                        Position: "Below Team",
                        Type: "About Page",
                      })
                    }
                  >
                    <Button className="aj-cta">
                      <Text strong>Start today</Text>
                      <FiArrowRight size={24} />
                    </Button>
                  </Link>
                </Paragraph>
              </Col>
            </Row>
          </Container>
        </Container>

        {/* Investor's section */}
        <Container type="fluid" className="about-investors">
          <Container>
            <Row align="middle" justify="center">
              <Col
                xs={{ span: 22, offset: 0 }}
                md={{ span: 8, offset: 0 }}
                flex={1}
              >
                <Title level={3} className="ai-title">
                  Our backers
                </Title>
              </Col>
              <Col xs={{ span: 22, offset: 0 }} md={{ span: 16, offset: 0 }}>
                <Row gutter={22}>
                  <Col xs={{ span: 24, offset: 0 }} md={{ span: 8, offset: 0 }}>
                    <Paragraph className="ai-card">
                      <TImage
                        src="/images/about/img-investor-1.png"
                        alt="Investor"
                        width={204}
                        height={37}
                      />
                    </Paragraph>
                  </Col>
                  <Col xs={{ span: 24, offset: 0 }} md={{ span: 8, offset: 0 }}>
                    <Paragraph className="ai-card">
                      <TImage
                        src="/images/about/img-investor-2.png"
                        alt="Titan Capital"
                        width={204}
                        height={37}
                      />
                    </Paragraph>
                  </Col>
                  <Col xs={{ span: 24, offset: 0 }} md={{ span: 8, offset: 0 }}>
                    <Paragraph className="ai-card">
                      <Space size={20}>
                        <TImage
                          src="/images/about/img-investor-3.svg"
                          alt="Titan Capital"
                          width={56}
                          height={56}
                        />
                        <Text strong style={{ fontSize: 24 }}>
                          20+ angels
                        </Text>
                      </Space>
                    </Paragraph>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </Container>

        {/* Contact Section */}
        <ContactUS />

        {/* Footer */}
        <PublicFooter />
      </Container>
    </PublicLayout>
  );
};

export default About;
